(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/my-profile-react/assets/react/pages/notifications/app-notifications/app-notifications.js') >= 0) return;  svs.modules.push('/modules/my-profile-react/assets/react/pages/notifications/app-notifications/app-notifications.js');
'use strict';

const {
  useEffect,
  useState
} = React;
const Checkbox = svs.ui.reactForm.Checkbox;
const {
  getPlayerPreferencesAsync,
  putCustomersProductTogglesAsync
} = svs.myProfile.react.pages.notifications.appNotifications.appNotificationsService;
const {
  showSettingsTechnicalError
} = svs.myProfile.react.shared.dialogs;
const {
  trackAppNotification
} = svs.myProfile.react.shared.tracking;
const AppNotifications = () => {
  const [loading, setLoadingState] = useState(true);
  const [notificationToggle, setNotificationToggle] = useState([]);
  const [mainChecked, setMainChecked] = useState(false);

  const checkForTruthy = toggles => Object.values(toggles).some(element => element === true);

  const getPreferenceData = React.useCallback(async () => {
    const {
      error,
      preferences
    } = await getPlayerPreferencesAsync();
    if (error) {
      showSettingsTechnicalError('På grund av ett tekniskt fel kan vi just nu inte visa dina inställningar. Vänligen försök igen senare.');
    }
    const toggles = (preferences === null || preferences === void 0 ? void 0 : preferences.notificationToggles) && JSON.parse(preferences.notificationToggles) || {};
    const toggleState = checkForTruthy(toggles);
    setNotificationToggle(toggleState);
    setLoadingState(false);
  }, []);
  useEffect(() => {
    getPreferenceData();
  }, [getPreferenceData]);
  useEffect(() => {
    setMainChecked(Boolean(notificationToggle));
  }, [notificationToggle]);

  const updateState = newTruthyState => {
    setNotificationToggle(newTruthyState);
  };

  const handleClickToggleAll = async () => {
    const newValue = !mainChecked;
    const togglesTemplate = {
      productName: 'all',
      toggleOn: newValue
    };
    const response = await putCustomersProductTogglesAsync(togglesTemplate);
    if (response !== null && response !== void 0 && response.error) {
      showSettingsTechnicalError('Ett fel inträffade när dina notifieringsinställningar skulle sparas, försök igen senare.');
      return null;
    }
    trackAppNotification(!mainChecked);
    updateState(newValue);
  };
  return React.createElement("div", null, !loading && React.createElement("div", {
    className: "margin-top"
  }, React.createElement(Checkbox, {
    checked: mainChecked,
    onChange: handleClickToggleAll
  }, "Notiser i v\xE5r app n\xE4r dina nummerspel \xE4r avgjorda och kan r\xE4ttas")));
};
svs.myProfile.react.pages.notifications.appNotifications.AppNotifications = AppNotifications;

 })(window);